const nb = {
  ACCESS_DENIED: 'Ingen tilgang',
  ACCESS_DENIED_HEADING: 'Du har ikke tilgang til denne digitale boken enda',
  ACCESS_DENIED_BUTTON_TEXT: 'Prov gratis i 30 dager',
  ACCESS_DENIED_CONTACT_TEXT: 'Spørsmal? Ta kontakt på <a href="mailto:digitalt@fagbokforlaget.no">digitalt@fagbokforlaget.no</a>',
  ALL: 'Alle',
  LOCALE: 'nb_NO',
  UI_LANG: 'Norsk bokmål',
  DICT_LANG: 'bokmål',
  LOGIN_BUTTON: 'Logg inn eller registrer deg',
  LOGIN_WELCOME: 'Innlogging for d-bok',
  LOGOUT: 'Logg ut',
  BOOK_COVER: 'Bokomslag',
  YOU_ARE_OFFLINE: 'Ingen Internett-tilgang',
  LANGUAGE: 'Språk',
  CHANGE_LANGUAGE: 'Velg språk',
  CHOOSE_LANGUAGE: 'Bytt språk',
  WHILE_ONLINE_TITLE: 'Les bøker med eller uten nettilkobling',
  WHILE_ONLINE: 'Du kan lese alle dine bøker når du er tilkoblet Internett. Hvis du vil lese bøker uten å være koblet til nett, må du laste dem ned først. Alle uthevinger og notater som du gjør når du er frakoblet, kommer til å synkroniseres når du kobler til Internett igjen.',
  OKAY: 'Greit!',
  GOT_IT: 'OK!',
  MY_LIBRARY: 'Mitt bibliotek',
  SORT_BY: 'Sorter etter',
  DOWNLOADED_BOOKS: 'Nedlastede bøker',
  DOWNLOADED: 'Nedlastet',
  DOWNLOADING: 'Nedlasting',
  RECENTLY_OPENED: 'Nylig åpnet',
  ORDER_ASC: 'Tittel A–Å',
  ORDER_DESC: 'Tittel Å–A',
  BOOK_DOWNLOAD: 'Last ned',
  BOOK_DOWNLOADING: 'Nedlasting',
  BOOK_READ: 'Les',
  SINCE_YOU_ARE_OFFLINE: 'Siden du er frakoblet, vil noen deler av applikasjonen være utilgjengelig fram til du er tilkoblet igjen.',
  TERMS_AND_CONDITIONS: 'Vilkår og betingelser',
  HELP: 'Hjelp',
  BACK_TO_LIBRARY: 'Tilbake til biblioteket',
  BACK_TO_THE_BOOK: 'Tilbake til boken',
  MY_NOTEBOOK: 'Min notatbok',
  TABLE_OF_CONTENTS: 'Innholdsfortegnelse',
  FAVORITES: 'Favoritter',
  HIGHLIGHTS: 'Uthevinger',
  HIGHLIGHTS_NO_CONTENT: 'Du har ikke lagt til noen uthevinger i denne boken.',
  NOTES: 'Notater',
  NEWEST: 'Nyeste først',
  WORDBANK: 'Ordbank',
  SEARCH_IN_BOOK: 'Søk i bok',
  SEARCH_PLACEHOLDER: 'Hva leter du etter?',
  SEARCH_RESULT_COUNT: 'resultater for søk',
  SEARCH_NO_RESULTS: 'Ingen resultater funnet',
  SEARCH_EMPTY_TEXT: 'Søkefeltet ditt er tomt.',
  SEARCH_OFFLINE_HEADING: 'Du er frakoblet',
  SEARCH_OFFLINE: 'Denne funksjonen er ikke tilgjengelig når du er frakoblet. Koble til Internett og prøv igjen.',
  SEARCH_LOADING: 'Søker...',
  SEARCH_NO_RESULTS_TEXT: 'Søk etter {phrase} ga ingen treff i denne boken. Prøv igjen med et annet søkeord.',
  SETTINGS: 'Innstillinger',
  SIZE_ASC: 'Størrelse stigende',
  SIZE_DESC: 'Størrelse synkende',
  SLIDER_PREVIOUS: 'Forrige',
  SLIDER_NEXT: 'Neste',
  PRINT: 'Skriv ut',
  DOWNLOAD: 'Last ned',
  TOC_NO_CONTENT: 'Denne boken har ingen innholdsfortegnelse.',
  SHOW_NAVIGATION: 'Vis navigasjon',
  HIDE_NAVIGATION: 'Skjul navigasjon',
  FAVORITES_NO_CONTENT: 'Ingen favoritter',
  FAVORITES_NOT_ADDED: 'Du har ikke lagt til noen favorittsider i denne boken.',
  ACTUAL_SIZE: 'Faktisk størrelse',
  FIT_TO_SCREEN: 'Tilpass skjermen',
  ZOOM_IN: 'Zoom inn',
  ZOOM_OUT: 'Zoom ut',
  ZOOM_CHANGE: 'Endre zoom',
  ZOOM_FIT_TO_SCREEN: 'Tilpass høyden',
  ANNOTATOR_HIGHLIGHT: 'Utheving',
  ANNOTATOR_ADD_NOTE: 'Notat',
  ANNOTATOR_WORDBANK: 'Ordbank',
  ANNOTATOR_LOOK_UP: 'Slå opp',
  LOOKUP_TITLE: 'Ordbok',
  LOOKUP_NO_CONTENT: 'Vi kunne dessverre ikke finne noen oversettelse for denne teksten.',
  NOTES_NO_CONTENT: 'Ingen notater',
  NOTES_NOT_ADDED: 'Du har ikke lagt til noen notater i denne boken.',
  DBOK_READER: 'D-bok Reader',
  DBOK_FILE: 'd-bok-data',
  LIBRARY: 'Bibliotek',
  SELECT_TO_ARCHIVE: 'Velg for å fjerne fra enhet',
  ARCHIVE: 'Fjern fra enhet',
  CANCEL: 'Avbryt',
  SAVE: 'Lagre',
  PROCESSING: 'Behandler...',
  DELETING: 'Sletter...',
  DELETE: 'Slette',
  PAGES_PER_VIEW: 'Sider per visning',
  EDIT_NOTE: 'Rediger notat',
  NEW_NOTE: 'Nytt notat',
  ONE_PAGE: 'Enkeltside',
  TWO_PAGES: 'Dobbeltside',
  PAGE: 'Side',
  GO_TO: 'Gå til',
  PAGES_OUT_OF_TOTAL: 'av {0}',
  AT: 'kl.',
  NEXT_PAGE: 'Neste side',
  PREVIOUS_PAGE: 'Forrige side',
  ADD_TO_FAVORITES: 'Legg til denne siden som favoritt',
  REMOVE_FROM_FAVORITES: 'Fjern denne siden som favoritt',
  HIDE_THUMBNAILS: 'Skjul miniatyrbilder',
  EXPAND_THUMBNAILS: 'Vis miniatyrbilder',
  PAGE_NUMBER: 'Sidetall',
  CLOSE_MESSAGE: 'Lukk denne meldingen',
  NEXT_THUMBNAILS_ROW: 'Next gruppe av miniatyrbilder',
  CLOSE_MENU: 'Lukk meny',
  CLEAR_INPUT: 'Rens søkefelt',
  FOCUS_INPUT: 'Fokus på søkefelt',
  NOTE: 'Notat',
  HIGHLIGHT: 'Utheving',
  TOGGLE_SUBCHAPTERS: 'Vis/skjul underkapitler',
  SEARCH_RESULT: 'Søkeresultat',
  IS_AVAILABLE_ONLINE: 'er tilgjengelig med nettilkobling',
  IS_AVAILABLE_OFFLINE: 'er tilgjengelig uten nettilkobling',
  SWITCH_TO_OLD_DBOK: 'Skift til gammel d-bok',
  BASE_FORM: 'Grunnform',
  WORD_CLASS: 'Ordklasse',
  FORM: 'Form',
  FROM: 'Fra',
  TO: 'Til',
  INFLECTION: 'Bøyning',
  VIEW_DETAILS: 'Vis detaljer',
  HIDE_DETAILS: 'Skjul detaljer',
  LISTEN_TO_PHRASE: 'Lytt til uttale',
  SYNONYMS: 'Synonymer',
  LOGIN_WELCOME_HEADING: 'Velkommen til Nye d-bok!',
  LOGIN_WELCOME_PARAGRAPH: 'Nye d-bok er et helt nyutviklet program for å lese Fagbokforlagets d-bøker.',
  LOGIN_WELCOME_LIST1: 'lese d-bøker i nettleseren også når du ikke har nettilgang',
  LOGIN_WELCOME_LIST2: 'ny teknologi og nytt design',
  LOGIN_WELCOME_INFO1: 'Siden dette er en betaversjon, er det noe funksjonalitet som ikke er klar ennå.',
  LOGIN_WELCOME_INFO2: 'Les mer på <a target="_blank" href="https://www.fagbokforlaget.no/d-bok">https://www.fagbokforlaget.no/d-bok</a>.',
  ALTERNATIVE_SPELLINGS: 'Alternativ skrivemåte',
  LOOKUP_LOADING: 'Slår opp...',
  FEEDBACK_TITLE: 'Gi oss en tilbakemelding',
  FEEDBACK_TEXT: 'Vi ønsker å høre fra deg! Hvordan kan vi forbedre våre d-bøker?',
  FEEDBACK_YOUR_EMAIL: 'E-post:',
  FEEDBACK_SUBMIT: 'Send',
  FEEDBACK_CLOSE: 'Lukk',
  FEEDBACK_THANK_YOU: 'Takk for tilbakemeldingen!',
  FEEDBACK_FAILED:  'Noe gikk galt ved innsending av skjemaet.',
  FEEDBACK_TEXT_REQUIRED: 'Skriv din tilbakemelding her.',
  FEEDBACK_EMAIL_REQUIRED: 'E-post er obligatorisk.',
  FEEDBACK_EMAIL_INVALID: 'E-postadressen er ikke gyldig.'
}

export default nb
